// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module__svg--oxNTG{width:100%;height:100%;fill:currentColor;border-radius:inherit;pointer-events:none}`, "",{"version":3,"sources":["webpack://./src/components/Media/Icon/style.module.scss"],"names":[],"mappings":"AAAA,0BACE,UAAA,CACA,WAAA,CACA,iBAAA,CACA,qBAAA,CACA,mBAAA","sourcesContent":[".svg {\n  width: 100%;\n  height: 100%;\n  fill: currentColor;\n  border-radius: inherit;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"svg": `style-module__svg--oxNTG`
};
export default ___CSS_LOADER_EXPORT___;
